import cx from 'classnames';
import { PRODUCT_FACET_LABELS } from 'mk/bazaar/product/filter/filterUtils';
import React from 'react';
import styles from './ProductFacets.mscss';

interface OwnProps {
    className?: string;
    facets: string[];
    small?: boolean;
}

type Props = OwnProps;

const ProductFacets = React.memo<Props>(({ className, facets, small = false }) => (
    <div className={cx(styles.ProductFacets, className)}>
        {facets.map((facet, index) => (
            <span
                key={index}
                className={cx(
                    styles.ProductFacets__facet,
                    small && styles['ProductFacets__facet--small'],
                    !small && styles['ProductFacets__facet--normal'],
                )}
            >
                {facet}
            </span>
        ))}
    </div>
));

ProductFacets.displayName = 'ProductFacets';

export default ProductFacets;
